import { theme } from "@common/theme/theme"
import { IS_WEB } from "@common/utils/mobileUtils"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import TextM from "@common/components/text/TextM"
import { TouchableRipple } from "react-native-paper"
import React from "react"
import { LinearGradient } from "expo-linear-gradient"
import * as WebBrowser from "expo-web-browser"
import * as amplitude from "@amplitude/analytics-react-native"

export const ReferralActionCard = (props) => {
    const { style, user } = props

    return (
        <TouchableRipple
            onPress={() => {
                amplitude.track("banner.clicked.referral")
                const url = user?.referrer_dashboard_url
                if (IS_WEB) {
                    window.open(url)
                } else {
                    WebBrowser.openBrowserAsync(url)
                }
            }}
            style={{
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
                backgroundColor: theme.colors.white,
                borderWidth: 1,
                borderColor: theme.colors.warning,
                borderRadius: 15,
                marginTop: 20,
                ...style,
            }}
            underlayColor={theme.colors.lightMore}
        >
            <LinearGradient
                style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    paddingLeft: 13,
                    paddingRight: 13,
                    paddingTop: 18,
                    paddingBottom: 18,
                    borderRadius: 15,
                }}
                colors={[
                    theme.colors.material.secondary["50"],
                    theme.colors.material.secondary["100"],
                ]}
            >
                <View
                    style={{
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        flexDirection: "row",
                        width: "100%",
                    }}
                >
                    <FontAwesome5
                        name={"gift"}
                        solid
                        color={theme.colors.warning}
                        size={24}
                    />

                    <View
                        style={{
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            marginLeft: 14,
                            flex: 1,
                        }}
                    >
                        <TextM
                            color={theme.colors.warning}
                            fontWeight="SemiBold"
                            fontSize={18}
                            wrap
                        >
                            Économisez{" "}
                            {(props.user?.referral_commission_amount ?? 50) * 2}
                            € pour 2 amis parrainés !
                        </TextM>
                        <TextM color={theme.colors.grey} fontSize={12} wrap>
                            Chaque parrainage vous rapporte{" "}
                            {props.user?.referral_commission_amount ?? 50}€,
                            alors n&apos;attendez pas et partagez votre lien de
                            parrainage !
                        </TextM>
                        <TextM
                            color={theme.colors.grey}
                            fontWeight="SemiBold"
                            fontSize={14}
                            wrap
                            style={{
                                marginTop: 6,
                            }}
                        >
                            En savoir plus
                        </TextM>
                    </View>
                </View>
            </LinearGradient>
        </TouchableRipple>
    )
}
